import { BasePalette } from '../general/color-palette';
import { Theme } from '../general/theme';
import { TextDirection } from '../general/text-direction';

const base: BasePalette = {
  100: '#212121', // Black
  120: '#1A1B1B',
  130: '#303131',
  140: '#222222',
  150: '#212121',
  200: '#4D4D4D',
  250: '#6C6C6C',
  350: '#194E77',
  400: '#507F70',
  500: '#FFBA00',
  600: '#D1D3D4',
  650: '#A51337',
  700: '#B4B4B4',
  750: '#BDBDBD',
  800: '#E7E7E7',
  850: '#ECECEC',
  900: '#FFFFFF', // White
};

export const jeepTheme: Theme = {
  currentDirection: 'ltr',
  color: {
    base,
    primary: base,
    secondary: base,
    accent: base,
  },
  font: {
    normal: 'Roboto, Arial',
    primary: 'ProximaNova, Arial',
    secondary: 'HelveticaNeue, Arial',
    tertiary: 'Roboto, Arial',
    accent: 'Roboto, Arial',
  },
  fontSize: {
    smaller: 11,
    small: 14,
    normal: 16,
    big: 24,
    bigger: 26,
    large: 36,
    extraLarge: 48,
    huge: 52,
  },
  breakPoint: {
    mobile: 450,
    tablet: 960,
    smallDesktop: 1280,
  },
  get direction() {
    return this.currentDirection;
  },
  set direction(direction: TextDirection) {
    this.currentDirection = direction;
  },
};
